import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Header, Icon, Input, List, Segment } from "semantic-ui-react";

const SelectedSkusPanel = ({ selectedSkus, setSelectedSkus, skuError, readOnly = false }) => {
  const intl = useIntl();
  const [filterQuery, setFilterQuery] = useState("");

  useEffect(() => {
    if (selectedSkus.length === 0) setFilterQuery("");
  }, [selectedSkus]);

  const visibleSkus = [...selectedSkus]
    .filter((item) => {
      if (!filterQuery) return true;
      const q = filterQuery.toLowerCase();
      return (
        String(item.item_name || "")
          .toLowerCase()
          .includes(q) ||
        String(item.sku_id || "")
          .toLowerCase()
          .includes(q)
      );
    })
    .sort((a, b) => {
      const nameA = String(a.item_name || a.sku_id || "");
      const nameB = String(b.item_name || b.sku_id || "");
      return nameA.localeCompare(nameB, undefined, { sensitivity: "base" });
    });

  return (
    <div style={{ display: "flex", flexDirection: "column", marginTop: "8px", opacity: readOnly ? 0.45 : undefined }}>
      {selectedSkus.length === 0 ? (
        <>
          <Segment
            placeholder
            style={{
              flex: 1,
              borderStyle: skuError ? "dashed" : undefined,
              borderColor: skuError ? "#db2828" : undefined,
            }}
          >
            <Header icon>
              <Icon name="briefcase" />
              {intl.formatMessage({
                id: "LABEL_SEARCH_SELECT_PRODUCTS_SKUS",
                defaultMessage: "Search and select products to attach SKUs",
              })}
            </Header>
          </Segment>
          {skuError && <div style={{ color: "#db2828", fontSize: "12px", marginTop: "6px" }}>{skuError}</div>}
        </>
      ) : (
        <>
          <Input
            fluid
            icon={
              filterQuery ? (
                <Icon
                  name="times circle"
                  link
                  onClick={() => setFilterQuery("")}
                />
              ) : (
                "filter"
              )
            }
            iconPosition={filterQuery ? undefined : "left"}
            placeholder={intl.formatMessage({
              id: "PLACEHOLDER_FILTER_SKUS",
              defaultMessage: "Filter by product name or sku…",
            })}
            value={filterQuery}
            onChange={(e) => setFilterQuery(e.target.value)}
            size="small"
            style={{ marginBottom: "8px" }}
          />
          <Segment
            style={{ maxHeight: "calc(100vh - 650px)", minHeight: "200px", overflowY: "auto", padding: "12px 16px" }}
          >
            {visibleSkus.length === 0 ? (
              <div style={{ textAlign: "center", color: "#888", padding: "20px 0", fontSize: "13px" }}>
                {intl.formatMessage({
                  id: "LABEL_NO_SKUS_MATCH_FILTER",
                  defaultMessage: "No products match your filter.",
                })}
              </div>
            ) : (
              <List
                divided
                relaxed
              >
                {visibleSkus.map((item) => (
                  <List.Item key={item.sku_id}>
                    {!readOnly && (
                      <List.Content floated="right">
                        <Icon
                          name="times"
                          link
                          onClick={() => setSelectedSkus((prev) => prev.filter((s) => s.sku_id !== item.sku_id))}
                        />
                      </List.Content>
                    )}
                    <List.Content>
                      {item.item_name && <List.Header>{item.item_name}</List.Header>}
                      <List.Description style={{ fontFamily: "monospace", fontSize: "11px" }}>
                        {item.sku_id}
                      </List.Description>
                    </List.Content>
                  </List.Item>
                ))}
              </List>
            )}
          </Segment>
        </>
      )}
    </div>
  );
};

export default SelectedSkusPanel;
